<!-- 
  顶部组件
 -->
 <template>
  <div class="nav_header">
    <div class="nav_header_top">
      <div class="ys_content">
        <span @click="navTo('/manager/index/index','',true)">管理后台</span>
        <div class="nav_header_topList ys_scrollbar">
          <span class="nav_header_topItem" @click="navTo('/manager/order/orderList','',true)">我的订单</span>
          <span class="nav_header_topItem" @click="navTo('/cart')">
            <i class="icon-gouwuche-fill"></i>购物车
          </span>
          <span class="nav_header_topItem" @click="navTo('/manager/goodsNew/goodsList','',true)">
            <i class="icon-shangpin2"></i>选品库</span>
          <span class="nav_header_topItem" style="color: var(--theme-color);" @click="navTo('/index')">选品中心</span>
          <span class="nav_header_topItem" @click="navTo('http://www2.douhuomall.com/manager/login/index','',true)">返回老版</span>
          <span class="nav_header_topItem">服务热线：18973183401</span>
        </div>
      </div>
    </div>
    <div class="ys_content mobile_nav">
      <div class="nav_header_middle">
        <div class="nav_header_left">
          <img class="nav_header_logo" :src="sysInfo.choice_top_logo|setImage" @click="select('index')" v-if="sysInfo.choice_top_logo">
          <img class="nav_header_logo" src="@/static/logo.png" @click="select('index')" v-else>
          <div class="nav_header_logoTips">
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">正</span>正品行货</div>
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">底</span>底价供货</div>
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">全</span>品类齐全</div>
          </div>
        </div>
        <div class="nav_header_search">
          <el-input class="nav_header_input" placeholder="商品名称/商品编码" v-model="searchText" clearable @clear="search(searchType,true)" @keyup.native.enter="search(searchType)">
            <el-select v-model="searchType" slot="prepend" placeholder="请选择">
              <el-option label="商品名称" :value="1"></el-option>
              <el-option label="商品编码" :value="2"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" v-waves @click="search(searchType)">搜索</el-button>
          </el-input>
        </div>
        <div class="nav_header_right">
          <button class="nav_header_btnItem" v-waves @click="navTo('/manager/goodsNew/goodsList','',true)">
            <i class="icon-shangpin"></i>选品库
            <span class="nav_header_btnNum" v-if="nums.choice_count>'0'">{{nums.choice_count | setNums}}</span>
          </button>
          <button class="nav_header_btnItem" v-waves @click="navTo('/cart')">
            <i class="icon-gouwuche"></i>购物车
            <span class="nav_header_btnNum" v-if="nums.cart_count>'0'">{{nums.cart_count | setNums}}</span>
          </button>
          <!-- <button class="nav_header_btnItem" v-waves @click="navTo('/index', null,false)"><i class="el-icon-arrow-left"></i>返回首页</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getCateGroup,
    getCategory,
    getNavbar,
    updateChoice,
    getHotSearch
  } from '@/api/common'

  import {
    debounce
  } from '@/utils/plugins'
  import {
    sendMsg,
    getMsg
  } from '@/utils/crossTagMsg'
  import {mapActions,mapState} from 'vuex'
  export default {
    name: 'NavHeader',
    data() {
      return {
        searchType: 1,//搜索类型
        searchText: '', //搜素内容
        hoverShow: false, //是否显示一级分类
        hoverLoading: false, //loading一级分类
        hoverChildShow: false, //是否显示二级分类
        hoverChildLoading: false, //loading二级分类

        cateGroupList: [], //一级分类
        cateGoryList: [], //展示的二级分类
        hoverIndex: '', //当前hover一级分类下标
        navBarList: [], //自定义选项卡
        hotSearch: [], //热搜词
        selectBar: '',
        nums: {
          choice_count: 0,
          limit_count: 0,
          margin_count: 0,
          update_count: 0,
          cart_count: 0
        },
        navScrollTo : 0,
        navScroll : 0
      }
    },
    watch: {
      $route(val) {
        this.initActive()
      }
    },
    computed:{
      ...mapState(['sysInfo']),
      pid(){
        if(this.navBarList){
          let parent = this.navBarList.find(item=>item.child.some(row=>row.nav_id==this.$route.query.id))||{};
          return parent.nav_id;
        }
      }
    },
    filters: {
      setNums(num) {
        return num > 99 ? '99+' : num;
      }
    },
    mounted() {
      //事件监听
      this.$bus.$on('headerChange', ({
        type,
        params
      }) => {
        if (type == 'data') {
          for (let key in params) {
            this[key] = params[key]
          }
        }else if(type=='addCart'){
          this.updateChoice()
        }
      })
      this.initActive()
      this.init()
      this.getSystemConfig();
    },
    methods: {
      ...mapActions(['getSystemConfig']),
      // 初始化
      init() {
        let cateGroupSave = getMsg('cateGroupList') || '';
        if (cateGroupSave && cateGroupSave.payload.length && Date.now() - cateGroupSave.temp < 1 * 60 * 60 * 1000) {
          //分类获取缓存 1小时内不更新
          this.cateGroupList = cateGroupSave.payload
        }

        let navBarSave = getMsg('navBarList') || '';
        if (navBarSave && navBarSave.payload.length && Date.now() - navBarSave.temp < 1) {
          //获取导航选项卡 1小时内不更新（1 * 60 * 60 * 1000）
          this.navBarList = navBarSave.payload
        } else {
          //获取导航选项卡
          // getNavbar().then(res => {
          //   if (res.error_code == 0) {
          //     this.navBarList = res.result;
          //     // [{
          //     //       "id": 11,
          //     //       "name": "全部商品",
          //     //       "type": 1,
          //     //       "version": "1",
          //     //       "sort": 98
          //     //     },{
          //     //       "id": 22,
          //     //       "name": "新品上架",
          //     //       "type": 2,
          //     //       "version": "1",
          //     //       "sort": 98
          //     //     },{
          //     //       "id": 33,
          //     //       "name": "权益充值",
          //     //       "type": 4,
          //     //       "version": "1",
          //     //       "sort": 98
          //     //   }];
          //     sendMsg('navBarList', this.navBarList, 'NavHeader')
          //   }
          // })
        }
        let hotSearch = getMsg('hotSearch') || '';
        if (hotSearch && hotSearch.payload.length && Date.now() - hotSearch.temp < 1 * 60 * 60 * 1000) {
          //获取热搜词 1小时内不更新
          this.hotSearch = hotSearch.payload
        } else {
          //获取热搜词
          getHotSearch({
            cate_id: 0,
            limit: 10
          }).then(res => {
            if (res.error_code == 0) {
              this.hotSearch = res.result;
              sendMsg('hotSearch', this.hotSearch, 'NavHeader')
            }
          })
        }
        this.updateChoice()
      },
      updateChoice(){
        //获取统计数字
        setTimeout(()=>{
            updateChoice({
              type: 0
            }).then(res => {
              if (res.error_code == 0) {
                this.nums = res.result;
                sendMsg('nums', this.nums, 'NavHeader')
              }
            })
        },5000)
      },
      /**
       * 父级调用更新页面数据
       * */
      initSave({
        key,
        params
      }) {
        this[key] = params;
      },
      /**
       * 选项卡选中
       * */
      initActive() {
        this.selectBar = this.$route.query.id;
      },
      /**
       * 选择
       * */
      select(item={}) {
        if(item.child&&item.child.length){
          item  = item.child[0];
        }
        let type = item.nav_type||0
        switch (type) {
          case 0:
            this.navTo('/index')
            break;
          case 1:
            this.navTo('/selection', {
              type,
              id: item.nav_id
            }, false, false)
            break;
          case 4:
            this.navTo('/topic', {
              type,
              id: item.nav_id
            }, false, false)
            break;
          case 5:
            this.navTo('/filmclient')
            break;
          case 2:
            //活动专题页
            // let url = item.version=='2' ? '/special' : '/topic';
            this.navTo('/topic', {
              type,
              id: item.nav_id
            }, false, false)
            break
          default:
            this.$message.warning('开发中');
        }
      },
      /**
       * 搜素 type 1商品名称搜索 2商品编码搜索
       * isClear true input清除事件
       * */
      search(type,isClear=false) {
        if(this.searchText.length<2&&!isClear){
          return this.$message.warning('搜索关键词不能少于两个字');
        }
        this.searchType = type;
        if(this.$route.path != '/local'){
          this.navTo('/local', {
            text: this.searchText,
            type
          })
        }else{
          this.$nextTick(() => {
            this.$bus.$emit('localSelectionSearch', {
              val: {
                type,
                text: this.searchText
              }
            })
          })
        }
      },
      /**
       * 商品分类鼠标事件
       * */
      navEnter(e) {
        this.hoverShow = true;
        if (!this.hoverLoading && this.cateGroupList.length == 0) {
          this.hoverLoading = true;
          getCateGroup({
            page: 0,
            limit: 0
          }).then(res => {
            this.hoverLoading = false;
            if (res.error_code == 0) {
              let list = res.result;
              list.forEach(item => {
                item.child = [];
              })
              this.cateGroupList = list;
              sendMsg('cateGroupList', list, 'NavHeader')
            }
          }).catch(() => {
            this.hoverLoading = false;
          })
        }
      },
      navLeave(e) {
        this.hoverShow = false;
        this.hoverChildShow = false;
        this.hoverIndex = ''
      },
      /**
       * 商品分类子元素鼠标事件
       * */
      navChildEnter(e) {
        this.hoverShow = true;
      },
      /**
       * 商品分类子元素移入获取数据
       * */
      navItemEnter(item, index) {
        this.hoverIndex = index;
        this.hoverChildShow = true;
        if (item.child.length) {
          this.hoverChildLoading = false;
          this.cateGoryList = this.cateGroupList[this.hoverIndex].child;
        } else {
          this.hoverChildLoading = true;
          this.cateGoryList = []
          this.getCategory(item)
        }
      },
      /**
       * 获取子分类
       * */
      getCategory: debounce(function(item) {
        getCategory({
          cate_pid: item.cate_pid,
          group_id: item.group_id
        }).then(res => {
          if (res.error_code == 0) {
            item.child = res.result.cate_list;
            if (this.cateGroupList[this.hoverIndex].group_id == item.group_id) {
              this.hoverChildLoading = false;
              this.cateGoryList = this.cateGroupList[this.hoverIndex].child;

              sendMsg('cateGroupList', this.cateGroupList, 'NavHeader')
            }
          }
        }).catch(() => {
          this.hoverChildLoading = false;
        })
      }),
      onMouseover(e,index,show=false){
        this.$set(this.navBarList[index],'childStyle',{})
        if(show){
          let parent = this.$refs.navHeader.getBoundingClientRect();
          let child = this.$refs.navHeaderItem[index].getBoundingClientRect();
          this.navBarList[index].childStyle = {
            display: 'block',
            left : `${child.left - parent.left}px`
          };
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .nav_header {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    --navItem-first: 200px;

    // 顶部
    &_top {
      height: 32px;
      line-height: 24px;
      font-size: 12px;
      color: #666;
      background-color: #F0F0F0;

      .ys_content {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      span {
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
      }
    }

    &_topList {
      height: 100%;
      display: flex;
      align-items: center;
      overflow-x: auto;
    }

    &_topItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding: 0 15px;
      white-space: nowrap;
      position: relative;
      margin: 0 10px;

      &~&::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 50%;
        width: 1px;
        height: 8px;
        margin-top: -4px;
        background-color: #ccc;
      }

      [class^=el-icon-],
      [class^=icon-] {
        font-size: 15px;
        color: var(--theme-color);
        margin-right: 4px;
      }

      &:not(:last-child):hover {
        background-color: #ccc;
        border-radius: 4px;
      }

      &:last-child {
        cursor: default;
        user-select: text;
      }
    }

    // 中间部分 搜索
    &_middle {
      display: flex;
      align-items: center;
      padding: 12px 0;
    }

    &_left {
      flex-shrink: 0;
      width: 308px;
    }

    &_logo {
      display: block;
      width: 200px;
      cursor: pointer;
    }

    &_logoTips {
      display: flex;
      align-items: center;
      margin-top: 12px;
    }

    &_logoTipItem {
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 12px;
      color: #999;
      padding-left: 26px;
      position: relative;
      // background: url('~@/static/header-tip1.png') 0 center no-repeat;
      // background-size: 19px auto;

      // &:nth-child(2) {
      //   background-image: url('~@/static/header-tip2.png');
      // }

      // &:nth-child(3) {
      //   background-image: url('~@/static/header-tip3.png');
      // }

      &~& {
        margin-left: 15px;
      }
    }

    &_icon{
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      color:var(--theme-color);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border: 1px solid var(--theme-color);
      border-radius: 50%;
      transform: scale(0.8);
    }

    &_search {
      flex: 1 0 0;
    }

    &_input {
      height: 40px;
      border-color: var(--theme-color);

      ::v-deep input {
        font-size: 14px;
        color: #333;
        height: 40px;
        line-height: 40px;
        border-color: var(--theme-color);

        &::-webkit-input-placeholder {
          font-size: 14px;
          color: #666;
        }
      }

      ::v-deep {
        .el-input-group__prepend{
          color: #fff;
          border-color: var(--theme-color);
          background-color: #fff;
        }
        .el-select{
          width: 110px;
          color: #999;
        }
        .el-input-group__append {
          padding: 0;
          color: #fff;
          border-color: var(--theme-color);
          background-color: var(--theme-color);
        }
        .el-button {
          height: 100%;
          margin: 0;
          border: none;
          color: #fff;
          background-color: var(--theme-color);
        }
      }
    }

    &_searchTips {
      height: 24px;
      overflow: hidden;
    }

    &_tipItem {
      display: inline-block;
      font-size: 12px;
      color: #999;
      line-height: 24px;

      b {
        display: inline-block;
        width: 1px;
        height: 12px;
        font-weight: 400;
        margin: 0 8px;
        background-color: #999;
        vertical-align: text-top;
      }
    }

    &_right {
      flex-shrink: 0;
      margin-left: 20px;
      display: flex;
    }

    &_btnItem {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 100px;
      height: 40px;
      padding: 0 8px;
      font-size: 12px;
      color: #333;
      border-radius: 4px;
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      cursor: pointer;

      &~& {
        margin-left: 14px;
      }

      [class^=el-icon-],
      [class^=icon-] {
        font-size: 24px;
        color: #808080;
        margin-right: 4px;
      }
    }

    &_btnNum {
      height: 18px;
      min-width: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;
      border-radius: 100px;
      font-size: 12px;
      color: #fff;
      margin-left: 9px;
      background-color: var(--theme-color);
    }

    // 导航部分
    &_nav {
      display: flex;
      margin-top: 20px;
      height: 44px;
      position: relative;
      &_scroll{
        position: absolute;
        right: 0;
        background-color: #fff;
        cursor: pointer;
        line-height: 44px;
      }
    }

    &_navItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 83px;
      font-size: 14px;
      cursor: pointer;

      &_list {
        flex: 1 0 0;
        display: flex;
        overflow-x: auto;
      }

      &:hover,
      &.active{
        color: var(--theme-color);
      }
      &:hover{
        .child{
          display: block;
        }
      }
      &_first {
        width: var(--navItem-first);
        background-color: var(--theme-color);
        color: #fff;

        &:hover {
          color: #fff;
        }
      }
      
      .child{
        display: none;
        position: absolute;
        top: 40px;
        width: inherit;
        z-index: 9999;
        text-align: center;
        line-height: 40px;
        background-color: #fff;
        box-shadow: 0 8px 5px 0 #0000002e;
        color: #000;
      }
      .child_item{
        &:hover,
        &.active {
          color: var(--theme-color);
        }
      }
    }

    &_hover {
      position: absolute;
      left: 0;
      top: 100%;
      width: var(--navItem-first);
      min-height: 300px;
    }

    &_hoverLoading {
      height: 100%;
      position: relative;
      z-index: 5;
    }

    &_hoverItem {
      display: flex;
      align-items: center;
      width: var(--navItem-first);
      height: 44px;
      padding: 0 20px 0 28px;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      background-color: var(--theme-color);
      border: 1px solid var(--theme-color);
      border-right: none;
      cursor: pointer;

      &:hover,
      &.active {
        background-color: #fff;
        color: var(--theme-color);
      }
    }

    &_hoverLine {
      font-size: 14px;
      padding: 0 1px;
      vertical-align: middle;
    }

    &_childCon {
      position: absolute;
      left: 100%;
      top: 1px;
      height: calc(100% - 1px);
      background-color: #fff;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
      overflow-y: auto;
    }

    &_childLoading {
      display: block;
      width: 100%;
      height: 100%;
      padding: 10px 0;
    }

    &_childItem {
      display: flex;
      font-size: 12px;
      color: #333;
      line-height: 22px;
      padding: 8px 20px;
    }

    &_childTitle {
      width: 92px;
      flex-shrink: 0;
      padding: 0 20px 0 10px;
      font-weight: bold;
      position: relative;

      >span {
        word-break: break-all;
      }

      .el-icon-arrow-right {
        position: absolute;
        right: 0;
        top: 5px;
        font-weight: 400;
      }
    }

    &_childList {
      flex: 1 0 0;
      display: flex;
      flex-wrap: wrap;
    }

    &_childText {
      padding: 0 10px;
    }
  }

  ._flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .hide_nav{
    height: 0;
    overflow: hidden!important;;
  }
  @media (min-width:1440px) {
    .nav_header_childCon {
      width: calc(1720px - var(--navItem-first));
    }
  }

  @media (max-width: $mediaWidth) {
    .mobile_nav{
      max-width: 1720px!important;
      margin: 0 auto;
      .nav_header_navItem{
        width: 92px!important;
      }
    }
    .nav_header_childCon {
      width: calc(998px - var(--navItem-first));
    }
    .nav_header_navItem:not(.nav_header_navItem_first){
      width: 99px;
    }
    .nav_header_ad{
      ul{
        width: 270px;
        li{
          min-width: 110px;
          font-size: 12px;
        }
      }
      &_webname{
        font-size: 28px;
      }
      &_dec{
        font-size: 18px;
      }
      &_more{
        width: 140px;
        line-height: 35px;
      }
    }
  }
</style>
